import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../../misc/constants";
import { DaarcBaseScenario } from "../../../../DaarcBaseScenario";
import { GeneralProceduresCricPart5Config, GeneralProceduresCricMainConfig } from "../GeneralProceduresCricMain";

export default class GeneralProceduresCricPart5 extends BaseScenarioPart<DaarcBaseScenario> {
	private get config(): GeneralProceduresCricPart5Config {
		return this.scenarioConfig.part5Config;
	}
	constructor(private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralProceduresCricMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		const context = this;

		context.scenario.addScore(context.scenario.cricInsertSpreaderPoints);
		if(context.config.onInsertingSpreader) {
			context.config.onInsertingSpreader();
		}
		var onDoneWithPopup = context._scenario.doSomething('Inserting Spreader...');
		context.playVideoChapter(context.config.spreaderVideoChapter(), () => {
			
		});

		setTimeout(() => {
			onDoneWithPopup();
			context.onDone();
		}, constants.doSomethingTimeout);
	}
}